import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button, Drawer, Layout as AntLayout } from 'antd';
import { 
  MenuOutlined, 
  HomeOutlined, 
  CarOutlined, 
  UserOutlined,
  InfoCircleOutlined
} from '@ant-design/icons';
import { useTheme } from '../../theme/ThemeProvider';
import Logo from '../Logo';
import './styles.css';

const { Header } = AntLayout;

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useTheme();
  const [drawerVisible, setDrawerVisible] = useState(false);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setDrawerVisible(false);
  };

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const menuItems = [
    {
      key: '/home',
      icon: <HomeOutlined />,
      label: 'خانه',
      path: '/home'
    },
    {
      key: '/tripsHistory',
      icon: <CarOutlined />,
      label: 'سفرها',
      path: '/tripsHistory'
    },
    {
      key: '/profile',
      icon: <UserOutlined />,
      label: 'پروفایل',
      path: '/profile'
    },
    {
      key: '/about',
      icon: <InfoCircleOutlined />,
      label: 'درباره ما',
      path: '/about'
    }
  ];

  return (
    <AntLayout className="main-layout">
      {/* Top Navigation Header */}
      <Header className="top-navigation-header" onClick={toggleDrawer}>
        <div className="header-content">
          {/* Logo */}
          <div className="logo-section">
            <Logo />
          </div>

          {/* Hamburger Menu Button */}
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              toggleDrawer();
            }}
            className="hamburger-menu-btn"
            style={{
              color: theme.text.primary,
              fontSize: '18px'
            }}
          />
        </div>
      </Header>

      {/* Main Content */}
      <div className="main-content" style={{ padding: 0 }}>
        {children}
      </div>

      {/* Left Side Drawer Menu */}
      <Drawer
        title="منو"
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width={320}
        className="side-menu-drawer"
        headerStyle={{
          backgroundColor: theme.surface,
          borderBottom: `1px solid ${theme.border}`,
          color: theme.text.primary
        }}
        bodyStyle={{
          backgroundColor: theme.surface,
          padding: 0
        }}
        style={{
          backgroundColor: theme.surface
        }}
      >
        <div className="drawer-menu">
          {menuItems.map((item) => (
            <Button
              key={item.key}
              type="text"
              onClick={() => handleNavigation(item.path)}
              className={`drawer-menu-item ${isActive(item.path) ? 'active' : ''}`}
              style={{
                width: '100%',
                height: 'auto',
                padding: '16px 20px',
                textAlign: 'right',
                border: 'none',
                borderRadius: 0,
                borderBottom: `1px solid ${theme.border}`,
                backgroundColor: isActive(item.path) ? theme.primary : 'transparent',
                color: isActive(item.path) ? '#fff' : theme.text.primary,
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start'
              }}
            >
              <span style={{ marginRight: '12px' }}>{item.icon}</span>
              {item.label}
            </Button>
          ))}
        </div>
      </Drawer>
    </AntLayout>
  );
};

export default Layout; 